/**
 * Loads the Microsoft Clarity snippet, only when a Project ID is configured.
 * Clarity's value is automatic — session recordings and click/scroll
 * heatmaps require no per-element instrumentation once this is loaded.
 */
export const loadClarity = (projectId) => {
  if (!projectId || window.clarity) return;

  window.clarity = function clarity() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  document.head.appendChild(script);
};
